import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const COMPANY_INFO = {
  name: 'Cordinal Mushrooms (Proprietor: Ganesh Maharaj M)',
  brand: 'MITOFORGE',
  address: '014, 5-58/2, Ganesh Bhawan, Jeeva Nagar 2nd Street, Erachakulam, Nagercoil–629901, Kanyakumari, Tamil Nadu, India',
  gstin: '33HCPPM8780M1ZK',
  fssai: 'Applied', // FSSAI Central licence applied
  email: 'contact@mitoforge.com',
  phone: '+91 63795 08969',
  website: 'mitoforge.com'
};

const LAST_UPDATED = 'July 10, 2026';

export const TermsPage = () => {
  return (
    <>
      <Navbar />
      <LegalPageLayout title="Terms & Conditions" lastUpdated={LAST_UPDATED}>
        <p>Welcome to mitoforge.com (the "Site"), operated by <strong>{COMPANY_INFO.name}</strong>, trading as <strong>{COMPANY_INFO.brand}</strong> ("we", "us", "our"). By accessing the Site or placing an order, you ("you", "customer") agree to these Terms & Conditions. If you do not agree, please do not use the Site.</p>
        
        <h2>1. Eligibility</h2>
        <p>You must be <strong>18 years or older</strong> and able to form a legally binding contract under Indian law to purchase from us. Our products are intended for healthy adults and are <strong>not for children, or for pregnant or nursing women</strong> except on the advice of a physician.</p>
        
        <h2>2. Products & Information</h2>
        <p>Our products are <strong>health supplements / nutraceuticals</strong> licensed under the FSS Act, 2006. Product descriptions, images and the research information on the Site are provided for general information and are <strong>not medical advice</strong>. Colours and pack images are indicative. We may update products, descriptions and prices at any time without notice.</p>
        
        <h2>3. No Medical Claims</h2>
        <p>{COMPANY_INFO.brand} products are <strong>not intended to diagnose, treat, cure or prevent any disease</strong> and are <strong>not a substitute for a balanced diet, medical advice, or prescribed medication</strong>. See our Disclaimer.</p>
        
        <h2>4. Pricing & Payment</h2>
        <p>All prices are in <strong>INR (₹)</strong> and, unless stated, inclusive of applicable taxes. Payment is collected through third-party payment gateways; we do not store your card details. We reserve the right to cancel any order where a pricing or stock error has occurred, with a full refund.</p>
        
        <h2>5. Orders & Acceptance</h2>
        <p>Your order is an offer to buy. A contract forms only when we <strong>confirm dispatch</strong>. We may refuse or cancel an order (e.g. stock, suspected fraud, delivery-area limits) and will refund any amount paid.</p>
        
        <h2>6. Shipping & Returns</h2>
        <p>Governed by our Shipping Policy and Returns & Refund Policy, which form part of these Terms.</p>
        
        <h2>7. Intellectual Property</h2>
        <p>The {COMPANY_INFO.brand} name, logo, content, images and site design are our property or licensed to us and may not be copied or used without written permission.</p>
        
        <h2>8. Acceptable Use</h2>
        <p>You agree not to misuse the Site, attempt unauthorised access, scrape content, or use it for unlawful purposes.</p>
        
        <h2>9. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, our total liability for any claim arising from a product or the Site is <strong>limited to the amount you paid for the product in question.</strong> We are not liable for indirect or consequential loss. Nothing here limits liability that cannot be excluded under law (including under the Consumer Protection Act, 2019).</p>
        
        <h2>10. Indemnity</h2>
        <p>You agree to indemnify us against claims arising from your misuse of the Site or breach of these Terms.</p>
        
        <h2>11. Governing Law & Jurisdiction</h2>
        <p>These Terms are governed by the laws of India. The courts at <strong>Nagercoil / Kanyakumari, Tamil Nadu</strong> have exclusive jurisdiction.</p>
        
        <h2>12. Changes</h2>
        <p>We may update these Terms; the current version is always posted here.</p>
        
        <h2>13. Contact</h2>
        <p>{COMPANY_INFO.email} · {COMPANY_INFO.phone}</p>
      </LegalPageLayout>
      <Footer />
    </>
  );
};

export const PrivacyPage = () => {
  return (
    <>
      <Navbar />
      <LegalPageLayout title="Privacy Policy" lastUpdated={LAST_UPDATED}>
        <p>This Privacy Policy explains how <strong>{COMPANY_INFO.name}</strong> ({COMPANY_INFO.brand}) collects, uses and protects your information, in line with the <strong>Information Technology Act, 2000</strong> & SPDI Rules, 2011 and the <strong>Digital Personal Data Protection Act, 2023</strong>.</p>
        
        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>You provide:</strong> name, email, phone, shipping/billing address, order details.</li>
          <li><strong>Payments:</strong> processed by our third-party gateway (e.g. Razorpay) — <strong>we do not store your card/UPI details</strong>.</li>
          <li><strong>Automatically:</strong> device/browser data, IP, and cookie data for site functionality and analytics.</li>
        </ul>
        
        <h2>2. How We Use It</h2>
        <p>To process and deliver orders, provide customer support, send order updates, improve the Site, prevent fraud, and — <strong>only with your consent</strong> — send marketing communications (you can opt out any time).</p>
        
        <h2>3. Cookies</h2>
        <p>We use cookies for basic functionality and analytics. You can disable cookies in your browser; some features may not work.</p>
        
        <h2>4. Sharing</h2>
        <p>We share data only with: <strong>logistics/courier partners</strong> (to deliver), <strong>payment gateways</strong> (to process payment), analytics providers, and where <strong>required by law</strong>. We <strong>do not sell</strong> your personal data.</p>
        
        <h2>5. Data Security</h2>
        <p>We apply reasonable security practices to protect your data. No method of transmission is 100% secure; we cannot guarantee absolute security.</p>
        
        <h2>6. Retention</h2>
        <p>We keep personal data only as long as needed for the purposes above and to meet legal/tax obligations, then delete or anonymise it.</p>
        
        <h2>7. Your Rights</h2>
        <p>You may request access to, correction of, or deletion of your personal data, and withdraw consent, by contacting our Grievance Officer below.</p>
        
        <h2>8. Children</h2>
        <p>The Site is not intended for anyone under 18; we do not knowingly collect their data.</p>
        
        <h2>9. Grievance Officer</h2>
        <p>Name: <strong>Ganesh Maharaj M</strong><br/>
        Email: <strong>{COMPANY_INFO.email}</strong><br/>
        Phone: <strong>{COMPANY_INFO.phone}</strong><br/>
        Address: {COMPANY_INFO.address}</p>
        <p>We aim to acknowledge complaints within <strong>48 hours</strong> and resolve them within the timelines prescribed by law.</p>
        
        <h2>10. Changes</h2>
        <p>We may update this Policy; the current version is posted here.</p>
      </LegalPageLayout>
      <Footer />
    </>
  );
};

export const ShippingPage = () => {
  return (
    <>
      <Navbar />
      <LegalPageLayout title="Shipping Policy" lastUpdated={LAST_UPDATED}>
        <h2>1. Where We Ship</h2>
        <p>We currently ship <strong>across India</strong>. International shipping is <strong>not yet available</strong>.</p>
        
        <h2>2. Processing Time</h2>
        <p>Orders are processed within <strong>1–2 business days</strong> (excluding Sundays/holidays). You'll receive a confirmation and tracking link once dispatched.</p>
        
        <h2>3. Delivery Time</h2>
        <p>Estimated delivery is <strong>3–7 business days</strong> after dispatch, depending on your location. These are estimates, not guarantees.</p>
        
        <h2>4. Shipping Charges</h2>
        <p>Shipping charges are calculated at checkout. Any charges are shown before you pay.</p>
        
        <h2>5. Courier Partners</h2>
        <p>We ship via reputable couriers (Shiprocket partners).</p>
        
        <h2>6. Tracking</h2>
        <p>A tracking number is emailed/SMSed on dispatch.</p>
        
        <h2>7. Delays</h2>
        <p>We are not responsible for delays caused by couriers, weather, strikes, or events beyond our control, but we will help you follow up.</p>
        
        <h2>8. Incorrect Address / Failed Delivery</h2>
        <p>Please enter your address correctly. If a parcel is returned due to a wrong address or repeated failed delivery, re-shipping charges may apply.</p>
        
        <h2>9. Damaged in Transit</h2>
        <p>If your parcel arrives damaged, <strong>do not accept it / photograph it</strong> and contact us within <strong>48 hours</strong>.</p>
        
        <h2>Contact</h2>
        <p>{COMPANY_INFO.email} · {COMPANY_INFO.phone}</p>
      </LegalPageLayout>
      <Footer />
    </>
  );
};

export const ReturnsPage = () => {
  return (
    <>
      <Navbar />
      <LegalPageLayout title="Returns & Refunds" lastUpdated={LAST_UPDATED}>
        <p>Because our products are <strong>consumable health supplements</strong>, we follow strict <strong>food-safety and hygiene</strong> rules on returns.</p>
        
        <h2>1. Cancellations</h2>
        <p>You may cancel an order <strong>before it is dispatched</strong> for a full refund. Once dispatched, it cannot be cancelled (see returns below).</p>
        
        <h2>2. Returns — Hygiene Rule</h2>
        <p>For safety and hygiene, <strong>we cannot accept returns of opened, used, or tampered products.</strong> Unopened products in original, sealed condition may be returned only in the cases below.</p>
        
        <h2>3. When We Accept a Return / Replacement</h2>
        <p>If you receive a product that is <strong>damaged, defective, expired, or incorrect</strong>, contact us within <strong>48 hours</strong> of delivery with your <strong>order number and photos</strong> of the item, seal and batch/expiry. After verification we will <strong>replace the item or refund you</strong>, including return shipping for our error.</p>
        
        <h2>4. Not Eligible</h2>
        <p>Opened/used items; items returned without prior approval; items past the reporting window; issues caused by misuse or improper storage.</p>
        
        <h2>5. Refund Method & Timeline</h2>
        <p>Approved refunds are made to your <strong>original payment method</strong> within <strong>7–10 business days</strong> of us receiving/verifying the return. Bank/gateway processing times may add a few days.</p>
        
        <h2>6. How to Raise a Request</h2>
        <p>Email <strong>{COMPANY_INFO.email}</strong> (subject: "Return – [Order No.]") or call <strong>{COMPANY_INFO.phone}</strong> with your order number, the issue, and photos.</p>
        
        <h2>7. Quality Guarantee</h2>
        <p>Every batch is quality-checked before dispatch. If anything is wrong, we will make it right — your safety and satisfaction come first.</p>
      </LegalPageLayout>
      <Footer />
    </>
  );
};

export const DisclaimerPage = () => {
  return (
    <>
      <Navbar />
      <LegalPageLayout title="Disclaimer" lastUpdated={LAST_UPDATED}>
        <p><strong>Please read carefully before using {COMPANY_INFO.brand} products or relying on any information on this Site.</strong></p>
        
        <h2>1. Health-Supplement, Not Medicine</h2>
        <p>{COMPANY_INFO.brand} products are <strong>health supplements / nutraceuticals</strong>, <strong>NOT FOR MEDICINAL USE</strong>. The statements on this Site <strong>have not been evaluated by the FSSAI</strong> and the products are <strong>not intended to diagnose, treat, cure or prevent any disease.</strong></p>
        
        <h2>2. Not Medical Advice</h2>
        <p>Content on this Site — including information about cordyceps, cordycepin and linked research — is for <strong>general educational purposes only</strong> and is <strong>not medical, health, or professional advice</strong>. It is not a substitute for consultation with a qualified healthcare professional.</p>
        
        <h2>3. Consult Your Doctor</h2>
        <p>Consult a physician before use if you are <strong>pregnant, nursing, under 18, have a medical condition, or take any medication</strong> (including blood thinners, immunosuppressants, or diabetes/blood-pressure medication). Discontinue use and seek medical advice if you experience any adverse reaction.</p>
        
        <h2>4. Allergen Note</h2>
        <p>This product may be manufactured using an environment that handles <strong>egg</strong> in the growth medium. Check the pack for the current ingredient and allergen declaration.</p>
        
        <h2>5. Individual Results Vary</h2>
        <p>The research cited is on cordyceps/cordycepin generally; <strong>it does not guarantee any specific result</strong> from our product. Effects, if any, vary by individual and depend on diet, lifestyle and consistent use.</p>
        
        <h2>6. Use as Directed</h2>
        <p>Do not exceed the recommended daily use. Keep out of reach of children. Store as directed on the pack.</p>
        
        <h2>7. External Links</h2>
        <p>The Site links to third-party research and websites for reference; we are not responsible for their content.</p>
        
        <h2>8. Limitation</h2>
        <p>To the maximum extent permitted by law, {COMPANY_INFO.name} / {COMPANY_INFO.brand} is not liable for any loss arising from use of, or reliance on, this Site or the products, beyond the limits set in our Terms & Conditions.</p>
        
        <h2>Contact</h2>
        <p>{COMPANY_INFO.email} · {COMPANY_INFO.phone}</p>
      </LegalPageLayout>
      <Footer />
    </>
  );
};
